export default __webpack_public_path__ + "assets/png/3447428f85190840f981fcde22b26e4b.png";